import { Component, OnInit, OnChanges, OnDestroy, Input, Output, EventEmitter, ViewChild, ElementRef, NgZone } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl, ValidationErrors } from '@angular/forms';
import { Candidate } from '../../../employee/class/candidate';
import { CandidateService } from '../../../employee/service/candidate/candidate.service';
import { TranslateService } from '@ngx-translate/core';
import { Message, FileUpload, RadioButtonModule, SelectItem, MultiSelectModule, AutoCompleteModule, CalendarModule, CheckboxModule } from 'primeng/primeng';
import { MapsAPILoader } from '@agm/core';
import { Marker } from '../../../../interfaces/marker';
import { NotificationsService } from '../../../../theme/services/notifications/notifications.service';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { UploadFilesService } from '../../../employee/service/upload-files/upload-files.service';
import { config } from '../../../../../environments/config';
import { HasPermissionService } from '../../../employee/service/has-permission/has-permission.service';
import { formatDate } from '../../../../theme/functions/formatDate.function';
import { calendarES } from '../../../../theme/functions/calendarES';
import { thousandsSeparator } from '../../../../theme/functions/thousandsSeparator.function';
import { ListEps } from '../../../disability/components/candidate-disabilities/data.constants';
import { CandidateEducationLevelOptions } from '../../../../shared/constans';


@Component({
  selector: 'app-candidate-hv',
  templateUrl: './candidate-hv.component.html',
  styleUrls: ['./candidate-hv.component.scss']
})
export class CandidateHvComponent implements OnInit {
  @Output() msg: EventEmitter<object> = new EventEmitter<object>();
  @Output() close: EventEmitter<any> = new EventEmitter<any>();
  @Input() verification: boolean;
  @Input() edit: Candidate;
  @Input() minimum: boolean;
  @Input() barcode: boolean;
  @Input() barcodeRead: string;
  @Input() dailyVisit: boolean;

  @ViewChild('search') public searchElementRef: ElementRef;
  public listDocuments: any[] = [];
  public documents_candidate: any[] = [];
  public contacts_candidate: any[] = [];
  public zoom: number;
  public marker: Marker;
  public barcode_identification_number: string;
  public barcode_name: string;
  public barcode_gender: string;
  public barcode_birthday: string;
  public barcode_blood: string;
  public promiseForm: Promise<any>;
  public form: FormGroup;
  public form2: FormGroup;
  public form3: FormGroup;
  public form4: FormGroup;
  public totalRecords: number;
  public page: number;
  public per_page: number;
  public sort: string;
  public query: string;
  // public filters: {key: string, value: string}[];
  public name: AbstractControl;
  public identification_number: AbstractControl;
  public gender: AbstractControl;
  public selectedGender: {label: string, value: string};
  public phone: AbstractControl;
  public mobile: AbstractControl;
  public email: AbstractControl;
  public address: AbstractControl;
  public salary_aspiration: AbstractControl;
  public date_birth: AbstractControl;
  public profession: AbstractControl;
  public profile_description: AbstractControl;
  public civil_status: AbstractControl;
  public childrens: AbstractControl;
  public work_area: AbstractControl;
  public activated: AbstractControl;
  public source: AbstractControl;
  public dated: AbstractControl;
  public id_type: AbstractControl;
  public expedition_date: AbstractControl;
  public expedition_city: AbstractControl;
  public lastname_1: AbstractControl;
  public lastname_2: AbstractControl;
  public name_1: AbstractControl;
  public name_2: AbstractControl;
  public eduacational_level: AbstractControl;
  // public phone_2: AbstractControl;
  public neighborhood: AbstractControl;
  public stratum: AbstractControl;
  public house_type: AbstractControl;
  public sisben: AbstractControl;
  public residence_city: AbstractControl;
  public residence_department: AbstractControl;
  public residence_country: AbstractControl;
  public birth_city: AbstractControl;
  public birth_department: AbstractControl;
  public birth_country: AbstractControl;
  public blood_type: AbstractControl;
  public weight: AbstractControl;
  public height: AbstractControl;
  public shoe_size: AbstractControl;
  public pant_size: AbstractControl;
  public shirt_size: AbstractControl;
  public female_hh: AbstractControl;
  public ethnicity: AbstractControl;
  public community: AbstractControl;
  public driving_license: AbstractControl;
  public driving_license_cat: AbstractControl;
  public work_accident: AbstractControl;
  public what_work_accident: AbstractControl;
  public eps: AbstractControl;
  public pension_fund: AbstractControl;
  public occupational_disease: AbstractControl;
  public what_occupational_disease: AbstractControl;
  public selectedStatus: {label: string, value: string};
  public sourceOptions: SelectItem[];
  public selectedSource: {label: string, value: string};
  public latitude: number;
  public longitude: number;
  public addressGoogle: string;
  public overlays: any[];
  public es: any;
  public idTypeOptions: any[];
  public genderOptions: any[];
  public civilStatusOptions: any[];
  public stratumOptions: any[];
  public houseTypeOptions: any[];
  public sisbenOptions: any[];
  public femaleHHOptions: any[];
  public ethnicityOptions: any[];
  public ethnicGroupOptions: any[];
  public bloodTypeOptions: any[];
  public weightOptions: any[];
  public shoeSizeOptions: any[];
  public pantSizeOptions: any[];
  public shirtSizeOptions: any[];
  public drivingLicenseOptions: any[];
  public drivingLicenseCatOptions: any[];
  public levelEducationOptions: any[] = CandidateEducationLevelOptions;
  public apiUrl = config.API_ROOT;
  public msgs: Message[];
  private id: number;
  public doRequest: number = 0;
  public heightId: string;
  public residenceCountryId: string = null;
  public residenceAdministrativeDivisionId: string = null;
  public residenceMunicipalityId: string = null;
  public birthCountryId: string = null;
  public birthAdministrativeDivisionId: string = null;
  public birthMunicipalityId: string = null;
  public work_experience: any[] = [];
  public save_exit: boolean;
  public listEps = ListEps;

  constructor(
    fb: FormBuilder,
    public candidateService: CandidateService,
    public translate: TranslateService,
    private ngZone: NgZone,
    private mapsAPILoader: MapsAPILoader,
    private notificationsService: NotificationsService,
    // public uploadFilesService: UploadFilesService,
    public hasPermissionService: HasPermissionService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.save_exit = false;

    this.es = calendarES();

    this.idTypeOptions = [
      // {label: 'choose', value: '', code_sorttime: ''},
      {label: 'C. C.', value: 'C. C.', code_sorttime: 'CIDCCC'},
      {label: 'C. E.', value: 'C. E.', code_sorttime: 'CIDCEE'},
      {label: 'T. I.', value: 'T. I.', code_sorttime: 'CIDTID'},
      {label: 'NIT', value: 'NIT', code_sorttime: 'CIDNIT'},
      {label: 'R. C.', value: 'R. C.', code_sorttime: 'CIDRCI'},
      {label: 'P. E.', value: 'P. E.', code_sorttime: 'CIDPEP'},
      {label: 'P. A.', value: 'P. A.', code_sorttime: 'CIDPAA'},
      {label: 'P. T.', value: 'P. T.', code_sorttime: 'CIDPAS'},
    ];

    this.genderOptions = [
      // {label: 'choose', value: '', code_sorttime: ''},
      {label: 'Femenino', value: 'Femenino', code_sorttime: 'SEXFEM'},
      {label: 'Masculino', value: 'Masculino', code_sorttime: 'SEXHOM'},
      {label: 'No binario', value: 'No binario', code_sorttime: 'SEXBIN'},
    ];

    this.civilStatusOptions = [
      // {label: 'choose', value: '', code_sorttime: ''},
      {label: 'Soltero(a)', value: 'Soltero(a)', code_sorttime: 'ECVSOL'},
      {label: 'Unión libre', value: 'Unión libre', code_sorttime: 'ECVLIB'},
      {label: 'Casado(a)', value: 'Casado(a)', code_sorttime: 'ECVCAS'},
      {label: 'Divorciado(a)', value: 'Divorciado(a)', code_sorttime: 'ECVDIV'},
      {label: 'Separado(a)', value: 'Separado(a)', code_sorttime: 'ECVSEP'},
      {label: 'Viudo(a)', value: 'Viudo(a)', code_sorttime: 'ECVVIU'},
    ];

    this.stratumOptions = [
      // {label: 'choose', value: '', code_sorttime: ''},
      {label: 'Estrato 1', value: 'Estrato 1', code_sorttime: 'ETO001'},
      {label: 'Estrato 2', value: 'Estrato 2', code_sorttime: 'ETO002'},
      {label: 'Estrato 3', value: 'Estrato 3', code_sorttime: 'ETO003'},
      {label: 'Estrato 4', value: 'Estrato 4', code_sorttime: 'ETO004'},
      {label: 'Estrato 5', value: 'Estrato 5', code_sorttime: 'ETO005'},
      {label: 'Estrato 6', value: 'Estrato 6', code_sorttime: 'ETO006'},
      {label: 'No aplica', value: 'No aplica', code_sorttime: 'ETO000'},              // Dejar este objeto siempre de último
    ];

    this.houseTypeOptions = [
      // {label: 'choose', value: '', code_sorttime: ''},
      {label: 'Arrendada', value: 'Arrendada', code_sorttime: 'CLG001'},
      {label: 'Familiar', value: 'Familiar', code_sorttime: 'CLG002'},
      {label: 'Propia sin hipoteca', value: 'Propia sin hipoteca', code_sorttime: 'CLG003'},
      {label: 'Propia con hipoteca', value: 'Propia con hipoteca', code_sorttime: 'CLG004'},
      {label: 'No especifica', value: 'No especifica', code_sorttime: 'CLG000'},      // Dejar este objeto siempre de último
    ];

    this.sisbenOptions = [
      // {label: 'choose', value: '', code_sorttime: ''},
      {label: 'Sí', value: 'Sí', code_sorttime: 'ING002'},
      {label: 'No', value: 'No', code_sorttime: 'ING001'},                            // Dejar este objeto siempre de último
    ];

    this.femaleHHOptions = [
      // {label: 'choose', value: '', status_sorttime: ''},
      {label: 'Sí', value: 'Sí', status_sorttime: true},
      {label: 'No', value: 'No', status_sorttime: false},                            // Dejar este objeto siempre de último
    ];

    this.ethnicityOptions = [
      // {label: 'choose', value: '', code_sorttime: '', selected: true},
      {label: 'Sí', value: 'Sí', code_sorttime: 'CCP001', selected: false},
      {label: 'No', value: 'No', code_sorttime: 'CCP000', selected: false},           // Dejar este objeto siempre de último
    ];

    this.ethnicGroupOptions = [
      // {label: 'choose', value: '', code_sorttime: ''},
      {label: 'Afrocolombiano', value: 'Afrocolombiano', code_sorttime: 'CCB001'},
      {label: 'Indígena', value: 'Indígena', code_sorttime: 'CCB002'},
      {label: 'Negro', value: 'Negro', code_sorttime: 'CCB003'},
      {label: 'Palenquero', value: 'Palenquero', code_sorttime: 'CCB005'},
      {label: 'Raizal', value: 'Raizal', code_sorttime: 'CCB004'},
      {label: 'No definido', value: 'No definido', code_sorttime: 'CCB000'},          // Dejar este objeto siempre de último
    ];

    this.bloodTypeOptions = [
      // {label: 'choose', value: '', code_sorttime: ''},
      {label: 'A-', value: 'A-', code_sorttime: 'TSG003'},
      {label: 'A+', value: 'A+', code_sorttime: 'TSG002'},
      {label: 'AB-', value: 'AB-', code_sorttime: 'TSG007'},
      {label: 'AB+', value: 'AB+', code_sorttime: 'TSG005'},
      {label: 'B-', value: 'B-', code_sorttime: 'TSG006'},
      {label: 'B+', value: 'B+', code_sorttime: 'TSG004'},
      {label: 'O-', value: 'O-', code_sorttime: 'TSG008'},
      {label: 'O+', value: 'O+', code_sorttime: 'TSG001'},
      {label: 'No definido', value: 'No definido', code_sorttime: 'TSG000'},
    ];

    this.weightOptions = [
      // {label: 'choose', value: '', code_sorttime: ''},
      {label: 'De 40 a 45 Kg', value: 'De 40 a 45 Kg', code_sorttime: 'PES001'},
      {label: 'De 46 a 50 Kg', value: 'De 46 a 50 Kg', code_sorttime: 'PES002'},
      {label: 'De 51 a 55 Kg', value: 'De 51 a 55 Kg', code_sorttime: 'PES003'},
      {label: 'De 56 a 60 Kg', value: 'De 56 a 60 Kg', code_sorttime: 'PES004'},
      {label: 'De 61 a 65 Kg', value: 'De 61 a 65 Kg', code_sorttime: 'PES005'},
      {label: 'De 66 a 70 Kg', value: 'De 66 a 70 Kg', code_sorttime: 'PES006'},
      {label: 'De 71 a 75 Kg', value: 'De 71 a 75 Kg', code_sorttime: 'PES007'},
      {label: 'De 76 a 80 Kg', value: 'De 76 a 80 Kg', code_sorttime: 'PES008'},
      {label: 'De 81 a 85 Kg', value: 'De 81 a 85 Kg', code_sorttime: 'PES009'},
      {label: 'De 86 a 90 Kg', value: 'De 86 a 90 Kg', code_sorttime: 'PES010'},
      {label: 'De 91 a 95 Kg', value: 'De 91 a 95 Kg', code_sorttime: 'PES011'},
      {label: 'No aplica', value: 'No aplica', code_sorttime: 'PES012'},              // Dejar este objeto siempre de último
    ];

    this.shoeSizeOptions = [
      // {label: 'choose', value: '', code_sorttime: ''},
      {label: 'Talla 34', value: 'Talla 34', code_sorttime: 'ZAP011'},
      {label: 'Talla 35', value: 'Talla 35', code_sorttime: 'ZAP001'},
      {label: 'Talla 36', value: 'Talla 36', code_sorttime: 'ZAP002'},
      {label: 'Talla 37', value: 'Talla 37', code_sorttime: 'ZAP003'},
      {label: 'Talla 38', value: 'Talla 38', code_sorttime: 'ZAP004'},
      {label: 'Talla 39', value: 'Talla 39', code_sorttime: 'ZAP005'},
      {label: 'Talla 40', value: 'Talla 40', code_sorttime: 'ZAP006'},
      {label: 'Talla 41', value: 'Talla 41', code_sorttime: 'ZAP007'},
      {label: 'Talla 42', value: 'Talla 42', code_sorttime: 'ZAP008'},
      {label: 'Talla 44', value: 'Talla 43', code_sorttime: 'ZAP009'},
      {label: 'Talla 44', value: 'Talla 44', code_sorttime: 'ZAP010'},
      {label: 'No definido', value: 'No definido', code_sorttime: 'ZAP000'},          // Dejar este objeto siempre de último
    ];

    this.pantSizeOptions = [
      // {label: 'choose', value: '', code_sorttime: ''},
      {label: 'Talla 6', value: 'Talla 6', code_sorttime: 'PAN013'},
      {label: 'Talla 8', value: 'Talla 8', code_sorttime: 'PAN006'},
      {label: 'Talla 10', value: 'Talla 10', code_sorttime: 'PAN007'},
      {label: 'Talla 12', value: 'Talla 12', code_sorttime: 'PAN008'},
      {label: 'Talla 14', value: 'Talla 14', code_sorttime: 'PAN009'},
      {label: 'Talla 16', value: 'Talla 16', code_sorttime: 'PAN010'},
      {label: 'Talla 18', value: 'Talla 18', code_sorttime: 'PAN014'},
      {label: 'Talla 20', value: 'Talla 20', code_sorttime: 'PAN015'},
      {label: 'Talla 28', value: 'Talla 28', code_sorttime: 'PAN001'},
      {label: 'Talla 30', value: 'Talla 30', code_sorttime: 'PAN002'},
      {label: 'Talla 32', value: 'Talla 32', code_sorttime: 'PAN003'},
      {label: 'Talla 34', value: 'Talla 34', code_sorttime: 'PAN004'},
      {label: 'Talla 36', value: 'Talla 36', code_sorttime: 'PAN005'},
      {label: 'Talla 38', value: 'Talla 38', code_sorttime: 'PAN011'},
      {label: 'Talla 40', value: 'Talla 40', code_sorttime: 'PAN012'},
      {label: 'No definido', value: 'No definido', code_sorttime: 'PAN000'},          // Dejar este objeto siempre de último
    ];

    this.shirtSizeOptions = [
      // {label: 'choose', value: '', code_sorttime: ''},
      {label: 'Talla S', value: 'Talla S', code_sorttime: 'CAM001'},
      {label: 'Talla M', value: 'Talla M', code_sorttime: 'CAM007'},
      {label: 'Talla L', value: 'Talla L', code_sorttime: 'CAM003'},
      {label: 'Talla XL', value: 'Talla XL', code_sorttime: 'CAM004'},
      {label: 'No definido', value: 'No definido', code_sorttime: 'CAM000'},          // Dejar este objeto siempre de último
    ];

    this.drivingLicenseOptions = [
      // {label: 'choose', value: '', code_sorttime: ''},
      {label: 'Sí', value: 'Sí', code_sorttime: 'Sí'},
      {label: 'No', value: 'No', code_sorttime: 'No'},                                // Dejar este objeto siempre de último
    ];

    this.drivingLicenseCatOptions = [
      // {label: 'choose', value: '', code_sorttime: ''},
      {label: 'A1', value: 'A1', code_sorttime: 'A1'},
      {label: 'A2', value: 'A2', code_sorttime: 'A2'},
      {label: 'B1', value: 'B1', code_sorttime: 'B1'},
      {label: 'B2', value: 'B2', code_sorttime: 'B2'},
      {label: 'C1', value: 'C1', code_sorttime: 'C1'},
      {label: 'C2', value: 'C2', code_sorttime: 'C2'},
      {label: 'C3', value: 'C3', code_sorttime: 'C3'},
      {label: 'No aplica', value: 'No aplica', code_sorttime: 'No aplica'},           // Dejar este objeto siempre de último
    ];

    
    this.documents_candidate = [
      {name: 'curriculum', id: 1},
      {name: 'DNI 150', id: 2},
      {name: 'Degree certificate or high school diploma', id: 6},
      {name: 'Certificates of technical, technological or professional studies', id: 6},
      {name: 'Certificates of complementary studies', id: 141},
      {name: 'certification job', id: 5},
      {name: 'Bank accounts certifications', id: 26},
      {name: 'Certification of layoffs', id: 183},
      // {name: 'EPS affiliation certification', id: 3},
      // {name: 'Pension fund certification', id: 4},
    ];

    this.form = fb.group({
      'id_type': ['', Validators.compose([ Validators.required, Validators.minLength(1) ]) ],
      'expedition_date': ['', Validators.compose([ Validators.required, Validators.minLength(1) ]) ],
      'expedition_city': ['', Validators.compose([ Validators.required, Validators.minLength(1) ]) ],
      'lastname_1': ['', Validators.compose([ Validators.required, Validators.minLength(1), Validators.pattern('^[a-zA-ZÀ-ÿ\u00f1\u00d1 ]*$') ]) ],
      'lastname_2': ['', Validators.compose([ Validators.pattern('^[a-zA-ZÀ-ÿ\u00f1\u00d1 ]*$') ]) ],
      'name_1': ['', Validators.compose([ Validators.required, Validators.minLength(1), Validators.pattern('^[a-zA-ZÀ-ÿ\u00f1\u00d1 ]*$') ]) ],
      'name_2': ['', Validators.compose([ Validators.pattern('^[a-zA-ZÀ-ÿ\u00f1\u00d1 ]*$') ]) ],
      'identification_number': ['', Validators.compose([ Validators.required, Validators.minLength(4), Validators.pattern("^[0-9]*$") ]) ],
      'gender': ['', Validators.compose([ Validators.required, Validators.minLength(1) ]) ],
      'phone': ['', Validators.compose([ Validators.minLength(7), Validators.maxLength(10), Validators.pattern('^[0-9]*$') ]) ],
      'mobile': ['', Validators.compose([ Validators.required, Validators.minLength(7), Validators.maxLength(10), Validators.pattern('^[0-9]*$') ]) ],
      'email': ['', Validators.compose([ Validators.required, Validators.minLength(4), Validators.pattern('^[a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,15})$') ]) ],
      'address': ['', Validators.compose([ Validators.required, Validators.minLength(5) ]) ],
      'date_birth': ['', Validators.compose([ Validators.required, Validators.minLength(1) ]) ],
      'civil_status': ['', Validators.compose([ Validators.required, Validators.minLength(1) ]) ],
      'residence_country':['', Validators.compose([ Validators.required, Validators.minLength(1) ]) ],
      'residence_department':['', Validators.compose([ Validators.required, Validators.minLength(1) ]) ],
      'residence_city':['', Validators.compose([ Validators.required, Validators.minLength(1) ]) ],
      'birth_country':[''],
      'birth_department':[''],
      'birth_city':[''],
      'neighborhood': [''],

      'activated': [''],
      'source': [''],
      'dated': [''],

    });
    this.form2 = fb.group({
      // 'recruited_by_id': [''],
      // 'psychologist_id': [''],

      'childrens': ['', Validators.compose([ Validators.pattern('^[0-9]*$') ]) ],
      // 'phone_2': ['', Validators.compose([ Validators.minLength(7), Validators.maxLength(10), Validators.pattern('^[0-9]*$') ]) ],
      'stratum': ['', Validators.compose([ Validators.required, Validators.minLength(1) ]) ],
      'house_type': ['', Validators.compose([ Validators.required, Validators.minLength(1) ]) ],
      'sisben': ['', Validators.compose([ Validators.required, Validators.minLength(1) ]) ],
      'female_hh': [''],
      'ethnicity': ['', Validators.compose([ Validators.required, Validators.minLength(1) ]) ],
      'community': [''],
      'blood_type': ['', Validators.compose([ Validators.required, Validators.minLength(1) ]) ],
      'weight': ['', Validators.compose([ Validators.required, Validators.minLength(1) ]) ],
      'shoe_size': ['', Validators.compose([ Validators.required, Validators.minLength(1) ]) ],
      'pant_size': ['', Validators.compose([ Validators.required, Validators.minLength(1) ]) ],
      'shirt_size': ['', Validators.compose([ Validators.required, Validators.minLength(1) ]) ],
      'height':['', Validators.compose([ Validators.required, Validators.minLength(1) ]) ],
      'driving_license': ['', Validators.compose([ Validators.required, Validators.minLength(1) ]) ],
      'driving_license_cat': [''],
    });
    this.form3 = fb.group({
      'eduacational_level': ['', Validators.compose([ Validators.required, Validators.minLength(1) ]) ],
      'profession': ['', Validators.compose([ Validators.required, Validators.minLength(1) ]) ],
    });

    this.form4 = fb.group({
      eps: ['', ([ Validators.required ])],
      'pension_fund': ['', Validators.compose ([ Validators.required, Validators.minLength(1) ]) ],
      'work_accident': ['', Validators.compose ([ Validators.required, Validators.minLength(1) ]) ],
      'what_work_accident' : ['', Validators.compose ([ Validators.minLength(10), Validators.maxLength(300) ]) ],
      'occupational_disease': ['', Validators.compose ([ Validators.required, Validators.minLength(1) ]) ],
      'what_occupational_disease' : ['', Validators.compose ([ Validators.minLength(10), Validators.maxLength(300) ]) ],
      'profile_description': [''],
      'salary_aspiration': ['',  Validators.compose([ Validators.pattern('^[0-9.,]*$') ]) ],
      'work_area': [''],
    });

    this.identification_number = this.form.controls['identification_number'];
    this.gender = this.form.controls['gender'];
    this.phone = this.form.controls['phone'];
    this.mobile = this.form.controls['mobile'];
    this.email = this.form.controls['email'];
    this.address = this.form.controls['address'];
    this.date_birth = this.form.controls['date_birth'];
    this.civil_status = this.form.controls['civil_status'];
    this.activated = this.form.controls['activated'];
    this.source = this.form.controls['source'];
    this.dated = this.form.controls['dated'];
    this.id_type = this.form.controls['id_type'];
    this.expedition_date = this.form.controls['expedition_date'];
    this.expedition_city = this.form.controls['expedition_city'];
    this.lastname_1 = this.form.controls['lastname_1'];
    this.lastname_2 = this.form.controls['lastname_2'];
    this.name_1 = this.form.controls['name_1'];
    this.name_2 = this.form.controls['name_2'];
    this.mobile = this.form.controls['mobile'];
    this.residence_country = this.form.controls['residence_country'];
    this.residence_department = this.form.controls['residence_department'];
    this.residence_city = this.form.controls['residence_city'];
    this.birth_country = this.form.controls['birth_country'];
    this.birth_department = this.form.controls['birth_department'];
    this.birth_city = this.form.controls['birth_city'];
    this.neighborhood = this.form.controls['neighborhood'];
    // this.phone_2 = this.form2.controls['phone_2'];
    this.childrens = this.form2.controls['childrens'];
    this.stratum = this.form2.controls['stratum'];
    this.house_type = this.form2.controls['house_type'];
    this.sisben = this.form2.controls['sisben'];
    this.female_hh = this.form2.controls['female_hh'];
    this.ethnicity = this.form2.controls['ethnicity'];
    this.community = this.form2.controls['community'];
    this.blood_type = this.form2.controls['blood_type'];
    this.weight = this.form2.controls['weight'];
    this.shoe_size = this.form2.controls['shoe_size'];
    this.pant_size = this.form2.controls['pant_size'];
    this.shirt_size = this.form2.controls['shirt_size'];
    this.height = this.form2.controls['height'];
    this.driving_license = this.form2.controls['driving_license'];
    this.driving_license_cat = this.form2.controls['driving_license_cat'];
    this.profession = this.form3.controls['profession'];
    this.eduacational_level = this.form3.controls['eduacational_level'];
    this.eps = this.form4.controls['eps'];
    this.pension_fund = this.form4.controls['pension_fund'];
    this.work_accident = this.form4.controls['work_accident'];
    this.what_work_accident = this.form4.controls['what_work_accident'];
    this.occupational_disease = this.form4.controls['occupational_disease'];
    this.what_occupational_disease = this.form4.controls['what_occupational_disease'];
    this.profile_description = this.form4.controls['profile_description'];
    this.work_area = this.form4.controls['work_area'];
    this.salary_aspiration = this.form4.controls['salary_aspiration'];


    this.sourceOptions = [
      { label: 'choose', value: '' },
      { label: 'Volanteo', value: 'Volanteo' },
      { label: 'Portal de candidatos', value: 'Portal de candidatos' },
      { label: 'Bolsa de Trabajo de la Universidad', value: 'Bolsa de Trabajo de la Universidad' },
      { label: 'Mercado Natural', value: 'Mercado Natural' },
      { label: 'Computrabajo', value: 'Computrabajo' },
      { label: 'El Empleo', value: 'El Empleo' },
      { label: 'Cliente', value: 'Cliente' },
      { label: 'Familiares o Amigos', value: 'Familiares o Amigos' },
      { label: 'Ferias', value: 'Ferias' },
      { label: 'Periodico o Revistas', value: 'Periódico o Revistas' },
      { label: 'Reclutador externo', value: 'Reclutador externo' },
      { label: 'Redes Sociales', value: 'Redes Sociales' },
      { label: 'SENA', value: 'SENA' },
      { label: 'Alentti', value: 'Alentti' },
      { label: 'Vincuventas', value: 'Vincuventas' },
      { label: 'LinkedIn', value: 'LinkedIn' },
      { label: 'Cajas de compensación', value: 'Cajas de compensación' },
      { label: 'Indeed', value: 'Indeed' },
      { label: 'Hoy Trabajas', value: 'Hoy Trabajas' },
      { label: 'Trabajos Diarios', value: 'Trabajos Diarios' },
      { label: 'empleosdeleje.com', value: 'empleosdeleje.com' },
      { label: 'Otro', value: 'Otro' },
    ];

    // set google maps defaults
    this.zoom = 2;
    this.latitude = 39.8282;
    this.longitude = -98.5795;

    this.marker = {
      lat: this.latitude,
      lng: this.longitude,
      label: 'User',
      draggable: true
    };
  }

  ngOnInit() {
    // console.log("el id es: " + this.id);
    // console.log("snapshot " + this.route.snapshot.paramMap.get('id'));
    if (this.route.snapshot.paramMap.get('candidate_id') != null)
      this.id = + this.route.snapshot.paramMap.get('candidate_id');
    if (this.router.url == '/candidate/curriculum')
      this.id = + JSON.parse(localStorage.getItem('profile')).candidate_id;
    if(this.id >= 0)
      this.minimum = false;

    if(this.id !== 0 && (this.id !== undefined)) {
        var promiseLoc = this.candidateService.infoCandidate(this.id).toPromise().then(
        response => {
          //console.log(response);
          this.edit = response.json();
          this.contacts_candidate = this.edit.contacts_candidate;
          this.work_experience = this.edit.work_experience;
          this.editValues();
          this.doRequest = 1;
        },
        error=>{
          this.notificationsService.growlNotify('error', 'ID ' + this.id + ' no encontrado');
          // this.router.navigateByUrl('/pages/candidate');
          // this.doRequest = 1;
        });
        this.getDocumentsCandidate(this.id);
    } else{
      this.doRequest = 1;
      this.activated.setValue(true);
      //this.dated.setValue(false);
      this.setCurrentPosition();
      // if (!this.minimum)
      //     this.locationGoogle();
    }

    // if (this.minimum) {
    //     this.email.setValidators(Validators.compose([Validators.minLength(4)]));
    // }

    if (this.barcode) {
      this.source.setValidators([Validators.required, Validators.minLength(1)]);
    }
  }

  public ngOnChanges() {
    // this.form.reset();
    // this.dated.setValue(false);
    this.parseRead();
  }

  public parseRead() {
    if (this.barcodeRead) {
      const res = this.barcodeRead.split(';');

      let id = '';
      let name1 = '';
      let name2 = '';
      let name3 = '';
      let name4 = '';

      if (res[0]) {
        id = res[0];
      } else {
        id = '';
      }

      if (res[1]) {
        name1 = res[1];
      } else {
        name1 = '';
      }

      if (res[2]) {
        name2 = res[2];
      } else {
        name2 = '';
      }

      if (res[3]) {
        name3 = res[3];
      } else {
        name3 = '';
      }

      if (res[4]) {
        name4 = res[4];
      } else {
        name4 = '';
      }

      this.barcode_identification_number = id;
      this.barcode_name = name3 + ' ' + name4 + ' ' + name1 + ' ' + name2;
      this.barcode_gender = res[5];
      // this.barcode_birthday = res[6];
      // this.barcode_birthday = this.barcode_birthday.substr(0,4) + '/' + this.barcode_birthday.substr(4,2) + '/' + this.barcode_birthday.substr(6,2)
      this.barcode_blood = res[7];

      if (this.minimum) {
        // this.email.setValidators(Validators.compose([Validators.minLength(4)]));
        if (this.barcode) {
          this.identification_number.setValue(this.barcode_identification_number.replace(/^0+/, ''));
          this.email.setValue(this.barcode_identification_number.replace(/^0+/, ''));

          // this.name.setValue(this.barcode_name.replace(/\s+/g,' '));
          this.name_1.setValue(this.barcode_name.replace(/\s+/g,' '));
          this.lastname_1.setValue(this.barcode_name.replace(/\s+/g,' '));

          // this.date_birth.setValue(new Date(this.barcode_birthday));
        }
      }
    } else {
      this.barcode_identification_number = undefined;
      this.barcode_name = undefined;
      this.barcode_gender = undefined;
      this.barcode_birthday = undefined;
      this.barcode_blood = undefined;
    }
  }

  private setCurrentPosition() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
        this.zoom = 17;
      });
    }
  }

  private setPosition(position) {
    this.latitude = position.lat;
    this.longitude = position.lng;
    this.zoom = 17;
  }

  public handleMapClick(event) {
    // this.selectedPosition = event.latLng;
    // this.addMarker(this.selectedPosition.lat(), this.selectedPosition.lng());
  }

  public addMarker(lat, lng) {
    const title = (this.name.value !== '') ? this.name.value : 'user';
    this.longitude = lng;
    this.latitude = lat;
    this.overlays = [];
    this.overlays.push(
      new google.maps.Marker({
        position: {
          lat: lat,
          lng: lng
        }, title: title}
      )
    );
  }

  markerDragEnd(m: Marker, $event: any) {
    this.latitude = $event.coords.lat;
    this.longitude = $event.coords.lng;
  }

  // public cancelCandidate() {
  //   // console.log('reset');
  //   this.form.reset();
  //   this.close.emit();
  //   this.barcodeRead = undefined;
  //   this.parseRead()
  // }

  public saveform (values) {
    let expedition_date = null;
    if(values.expedition_date != '' && values.expedition_date != null)
      expedition_date = formatDate(values.expedition_date );

    let date_birth = null;    // let date_birth = values.date_birth;
    if(values.date_birth != '' && values.date_birth != null)
      date_birth = formatDate(values.date_birth );

    let source;
    if (values.source) {
      if (values.source.value) {
        source = values.source.value;
      }
    }

    values.name_1 = values.name_1.trim().toUpperCase();

    if(values.name_2 != null && values.name_2 != '')
      values.name_2 = values.name_2.trim().toUpperCase();

    values.lastname_1 = values.lastname_1.trim().toUpperCase();

    if(values.lastname_2 != null && values.lastname_2 != '')
      values.lastname_2 = values.lastname_2.trim().toUpperCase();

    var name = values.name_1;

    if (values.name_2)
      name +=  ' ' + values.name_2;

    name += ' ' + values.lastname_1;

    if (values.lastname_2)
      name += ' ' + values.lastname_2;

    values['name']=name;
    var param = this.paramBuilding(values,1);
    this.newCandidate(param);
  }

  public saveform2 (values) {
    // values.gender.value
    values['gender'] = this.gender.value;
    var param = this.paramBuilding(values,2);
    this.newCandidate(param);
  }
  public saveform3 (values) {
    var param = this.paramBuilding(values,3);
    this.newCandidate(param);
  }
  public saveform4 (values) {
    var param = this.paramBuilding(values,4);
    this.newCandidate(param);
  }

  public newCandidate(param) {

    let register_date;

    if(this.edit){
      if(this.edit.created_at == null)
        register_date = formatDate(new Date());
      else
        register_date = this.edit.created_at;

    } else {
      register_date = formatDate(new Date());
    }


    if (param) {//if (values && this.form.valid) {
      const promise = (this.edit) ?
      this.candidateService.updateCandidate(this.edit.id, param)
      :
      this.candidateService.newCandidate(param);

      this.promiseForm = promise.toPromise().then(
        response => {
          this.edit = response.json();
          this.editValues();
          this.translate.get('saved').subscribe((res: string) => {
            this.notificationsService.growlNotify('success', res);
            // this.msg.emit( { severity: 'success', summary: res  } );
            // if (this.save_exit) {
            //   this.close.emit(response.json());
            //   this.form.reset();
            //   this.save_exit = false;
            // }
          });
          // this.router.navigateByUrl('/candidate/curriculum');
        },
        error => {
          let msg = '';
          this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
            this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
              JSON.parse(error._body).errors.forEach(element => {
                if (element.source) {
                  if (element.source.pointer) {
                    this.translate.get(element.source.pointer).subscribe((res3: string) => {
                      msg = msg + res3 + ', ';
                    });
                  }
                }
              });
              this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
              // this.msg.emit( { severity: 'error', summary: 'Error' } );
            });
          });
        }
      );
    }
  }

  getFormValidationErrors(form) {
    let value = '';
    Object.keys(form.controls).forEach(key => {
      const controlErrors: ValidationErrors = this.form.get(key).errors;
      if (controlErrors != null) {
        Object.keys(controlErrors).forEach(keyError => {
          value = 'Key control: ' + key + ', keyError: ' + keyError + ', err value: ' + controlErrors[keyError];
        });
      }
    });
    return (value);
  }

  public editValues() {
    this.identification_number.setValue(this.edit.identification_number);
    // this.gender.setValue(this.edit.gender);
    // this.selectedGender = {label: this.edit.gender, value: this.edit.gender};
    this.phone.setValue(this.edit.phone);
    this.mobile.setValue(this.edit.mobile);
    this.email.setValue(this.edit.email);
    this.address.setValue(this.edit.address);
    this.salary_aspiration.setValue(thousandsSeparator(this.edit.salary_aspiration));

    // this.profession.setValue(this.edit.profession_id);
    this.profile_description.setValue(this.edit.profile_description);
    this.source.setValue(this.edit.source);
    // this.civil_status.setValue(this.edit.civil_status);
    this.childrens.setValue(this.edit.childrens);
    this.work_area.setValue(this.edit.work_area);
    this.activated.setValue(this.edit.activated);
    // this.selectedStatus = {label: this.edit.civil_status, value: this.edit.civil_status};
    if (this.edit.latitude && this.edit.longitude) {
      const lat = this.edit.latitude;
      const lng = this.edit.longitude;
      const position = {
        lat : lat,
        lng : lng
      };
      this.setPosition(position);
    }
    // if (!this.minimum)
    //     this.locationGoogle();

    // this.id_type.setValue(this.edit.id_type);
    // this.identification_number.setValue(this.edit.identification_number);

    if (this.edit.expedition_date)
      this.expedition_date.setValue(new Date(this.edit.expedition_date));

    if (this.edit.date_birth)
      this.date_birth.setValue(new Date(this.edit.date_birth));

    this.expedition_city.setValue(this.edit.expedition_city);
    this.lastname_1.setValue(this.edit.lastname_1);
    this.lastname_2.setValue(this.edit.lastname_2);
    this.name_1.setValue(this.edit.name_1);
    this.name_2.setValue(this.edit.name_2);
    // this.phone_2.setValue(this.edit.phone_2);
    // this.address.setValue(this.edit.address);
    this.neighborhood.setValue(this.edit.neighborhood);
    // this.stratum.setValue(this.edit.stratum);
    // this.house_type.setValue(this.edit.house_type);
    // this.sisben.setValue(this.edit.sisben);
    // this.female_hh.setValue(this.edit.female_hh);
    // this.ethnicity.setValue(this.edit.ethnicity);
    // this.community.setValue(this.edit.community);
    // this.blood_type.setValue(this.edit.blood_type);
    // this.weight.setValue(this.edit.weight);
    // this.shoe_size.setValue(this.edit.shoe_size);
    // this.pant_size.setValue(this.edit.pant_size);
    // this.shirt_size.setValue(this.edit.shirt_size);
    this.eduacational_level.setValue(this.edit.eduacational_level);
    // this.height.setValue(this.edit.height);
    this.heightId = this.edit.height_id;
    // this.countryId = this.edit.residence_country;
    // this.administrativeDivisionId = this.edit.residence_department;
    // this.municipalityId = this.edit.residence_city;

    this.residenceMunicipalityId = this.edit.residence_city;
    this.residenceAdministrativeDivisionId = this.edit.residence_department;
    this.residenceCountryId = this.edit.residence_country;

    this.residence_city.setValue(this.edit.residence_city);
    this.residence_department.setValue(this.edit.residence_department);
    this.residence_country.setValue(this.edit.residence_country);
    // this.countryId = this.edit.birth_country;
    // this.administrativeDivisionId = this.edit.birth_department;
    // this.municipalityId = this.edit.birth_city;

    this.birthMunicipalityId = this.edit.birth_city;
    this.birthAdministrativeDivisionId = this.edit.birth_department;
    this.birthCountryId = this.edit.birth_country;

    this.birth_country.setValue(this.edit.birth_country);
    this.birth_department.setValue(this.edit.birth_department);
    this.birth_city.setValue(this.edit.birth_city);
    // this.profession.setValue(this.edit.profession);
    // this.driving_license.setValue(this.edit.driving_license);
    // this.driving_license_cat.setValue(this.edit.driving_license_cat);
    // this.created_by_id.setValue(this.edit.created_by_id);

    if (this.edit.id_type != null && this.edit.id_type != '')
      this.id_type.setValue(this.idTypeOptions.find(element => element.value == this.edit.id_type));

    if (this.edit.gender != null && this.edit.gender != '')
      this.gender.setValue(this.genderOptions.find(element => element.value == this.edit.gender));

    if (this.edit.civil_status != null && this.edit.civil_status != '')
      this.civil_status.setValue(this.civilStatusOptions.find(element => element.value == this.edit.civil_status));

    if (this.edit.stratum != null && this.edit.stratum != '')
      this.stratum.setValue(this.stratumOptions.find(element => element.value == this.edit.stratum));

    if (this.edit.house_type != null && this.edit.house_type != '')
      this.house_type.setValue(this.houseTypeOptions.find(element => element.value == this.edit.house_type));

    if (this.edit.sisben != null && this.edit.sisben != '')
      this.sisben.setValue(this.sisbenOptions.find(element => element.value == this.edit.sisben));

    if (this.edit.female_hh != null && this.edit.female_hh != '')
      this.female_hh.setValue(this.femaleHHOptions.find(element => element.value == this.edit.female_hh));

    if (this.edit.ethnicity != null && this.edit.ethnicity != '')
      this.ethnicity.setValue(this.ethnicityOptions.find(element => element.value == this.edit.ethnicity));

    if (this.edit.community != null && this.edit.community != '')
      this.community.setValue(this.ethnicGroupOptions.find(element => element.value == this.edit.community));

    if (this.edit.blood_type != null && this.edit.blood_type != '')
      this.blood_type.setValue(this.bloodTypeOptions.find(element => element.value == this.edit.blood_type));

    if (this.edit.weight != null && this.edit.weight != '')
      this.weight.setValue(this.weightOptions.find(element => element.value == this.edit.weight));

    if (this.edit.shoe_size != null && this.edit.shoe_size != '')
      this.shoe_size.setValue(this.shoeSizeOptions.find(element => element.value == this.edit.shoe_size));

    if (this.edit.pant_size != null && this.edit.pant_size != '')
      this.pant_size.setValue(this.pantSizeOptions.find(element => element.value == this.edit.pant_size));

    if (this.edit.shirt_size != null && this.edit.shirt_size != '')
      this.shirt_size.setValue(this.shirtSizeOptions.find(element => element.value == this.edit.shirt_size));

    if (this.edit.driving_license != null && this.edit.driving_license != '')
      this.driving_license.setValue(this.drivingLicenseOptions.find(element => element.value == this.edit.driving_license));

    if (this.edit.driving_license_cat != null && this.edit.driving_license_cat != '')
      this.driving_license_cat.setValue(this.drivingLicenseCatOptions.find(element => element.value == this.edit.driving_license_cat));

    this.form.get('identification_number').disable();
    this.form.get('email').disable();

    this.eps.setValue(this.edit.eps);
    this.pension_fund.setValue(this.edit.pension_fund);
    this.work_accident.setValue(this.edit.work_accident.toString());
    this.what_work_accident.setValue(this.edit.what_work_accident);
    this.occupational_disease.setValue(this.edit.occupational_disease.toString());
    this.what_occupational_disease.setValue(this.edit.what_occupational_disease);
  }

  public locationGoogle() {
    // load Places Autocomplete
    setTimeout(() => {
      this.mapsAPILoader.load().then(() => {
        const autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
          types: ['address']
        });
        autocomplete.addListener('place_changed', () => {
          this.ngZone.run(() => {
          // get the place result
          const place: google.maps.places.PlaceResult = autocomplete.getPlace();

          this.addressGoogle = place.formatted_address;
          // verify result
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }

          // set latitude, longitude and zoom
          this.latitude = place.geometry.location.lat();
          this.longitude = place.geometry.location.lng();
          this.zoom = 17;
          });
        });
      });
    }, 500);
  }

  public paramBuilding(values:any, numberForm:number){
    var param;
    if (numberForm == 1) {
      param = {
        'identification_number': values.identification_number,
        'name': values.name,
        'gender': values.gender.value,
        'phone': values.phone,
        'mobile': values.mobile,
        'email': values.email,
        'date_birth': formatDate(values.date_birth),
        'civil_status': values.civil_status.value,
        'activated': values.activated,
        'address': values.address,
        'latitude': this.latitude,
        'longitude': this.longitude,
        'daily_visit': (this.dailyVisit == undefined) ? null : this.dailyVisit,
        'id_type': values.id_type.value,
        'expedition_date': (values.expedition_date == '') ? null : formatDate(values.expedition_date),
        'expedition_city': values.expedition_city.id,
        'lastname_1': values.lastname_1,
        'lastname_2': values.lastname_2,
        'name_1': values.name_1,
        'name_2': values.name_2,
        'neighborhood': values.neighborhood,
        'residence_country': values.residence_country.id,
        'residence_department': values.residence_department.id,
        'residence_city': values.residence_city.id,
        'birth_country': (values.birth_country == '' || values.birth_country == null) ? null : values.birth_country.id,
        'birth_department': (values.birth_department == '' || values.birth_department == null) ? null : values.birth_department.id,
        'birth_city': (values.birth_city == '' || values.birth_city == null) ? null : values.birth_city.id,
      };
    } else if (numberForm == 2) {
      param = {
        'childrens': values.childrens,
        // 'phone_2': values.phone_2,
        'stratum': (values.stratum == '' || values.stratum == null) ? this.stratumOptions[this.stratumOptions.length - 1].value : values.stratum.value,
        'house_type': (values.house_type == '' || values.house_type == null) ? this.houseTypeOptions[this.houseTypeOptions.length - 1].value : values.house_type.value,
        'sisben': (values.sisben == '' || values.sisben == null) ? this.sisbenOptions[this.sisbenOptions.length - 1].value : values.sisben.value,
        'female_hh': (values.gender.value == 'Femenino') ? values.female_hh.value : this.femaleHHOptions[this.femaleHHOptions.length - 1].value,
        'ethnicity': (values.ethnicity == '' || values.ethnicity == null) ? this.ethnicityOptions[this.ethnicityOptions.length - 1].value : values.ethnicity.value,
        'community': (values.ethnicity.value == 'Sí') ? values.community.value : this.ethnicGroupOptions[this.ethnicGroupOptions.length - 1].value,
        'blood_type': values.blood_type.value,
        'weight': (values.weight == '' || values.weight == null) ? this.weightOptions[this.weightOptions.length - 1].value : values.weight.value,
        'shoe_size': (values.shoe_size == '' || values.shoe_size == null) ? this.shoeSizeOptions[this.shoeSizeOptions.length - 1].value : values.shoe_size.value,
        'pant_size': (values.pant_size == '' || values.pant_size == null) ? this.pantSizeOptions[this.pantSizeOptions.length - 1].value : values.pant_size.value,
        'shirt_size': (values.shirt_size == '' || values.shirt_size == null) ? this.shirtSizeOptions[this.shirtSizeOptions.length - 1].value : values.shirt_size.value,
        'height_id': (values.height == '' || values.height == null) ? null : values.height.id,
        'driving_license': (values.driving_license == '' || values.driving_license == null) ? this.drivingLicenseOptions[this.drivingLicenseOptions.length - 1].value : values.driving_license.value,
        'driving_license_cat': (values.driving_license.value == 'Sí') ? values.driving_license_cat.value : this.drivingLicenseCatOptions[this.drivingLicenseCatOptions.length - 1].value,
      };
    } else if(numberForm == 3) {
      param = {
        'eduacational_level': values.eduacational_level,
        'profession': (values.profession == '' || values.profession == null) ? null : values.profession.name,
        'profession_id': (values.profession == '' || values.profession == null) ? null : values.profession.id,
      };
    } else if(numberForm == 4) {
      param = {
        'eps': values.eps,
        'pension_fund': values.pension_fund,
        'work_accident': this.strToBool(values.work_accident),
        'what_work_accident': (values.work_accident == 'true') ? values.what_work_accident : '',
        'occupational_disease': this.strToBool(values.occupational_disease),
        'what_occupational_disease': (values.occupational_disease == 'true') ? values.what_occupational_disease : '',
        'salary_aspiration': values.salary_aspiration.replace(/[\.,]/g, ''),
        'profile_description': values.profile_description,
        'work_area': values.work_area,
      };
    } else{}
    return param;
  }



  public findValueSorttimeArrayOptions(value:string, nameArray: any[]) {
    var resp;
    nameArray.forEach(element =>{
      if(element.value == value)
        resp = element.code_sorttime;
    });
    return resp;
  }

  public findArrayOptions(value:string, nameArray: any[]) {
    var resp;
    nameArray.forEach(element =>{
      if(element.value == value)
        element.selected = true;
      else
        element.selected = false;
    });
  }

  public getStatusObject(eventObjetc, nameObject: string){
    var status = false;
    if(eventObjetc) {
      if (eventObjetc.value == nameObject)
        status = true;
    }
    return status;
  }

  public sorttimeFormatDate(date) {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    let year = d.getFullYear();

    if (month.length < 2)
      month = '0' + month;

    if (day.length < 2)
      day = '0' + day;

    return [day, month, year].join('/');
  }

  public getDocumentsCandidate(candidate_id: number) {
    this.candidateService.getDocumentsCandidate(candidate_id).toPromise().then(
      response => {
        // this.listDocuments = [];
        // this.result = response.json();
        // console.log('tipo : ' + typeof(this.result));
        // let list = [...this.listDocuments];
        // this.result.data.forEach(element => {
        //     if(element.document_profile_survey.length>0){
        //         for(var x=0;x<element.document_profile_survey.length;x++){
        //             if(element.document_profile_survey[x].expires_at) element.document_profile_survey[x].expires_at= new Date(element.document_profile_survey[x].expires_at);
        //         }
        //     }
        //     if (element.type == type) {
        //         list.push(element);
        //     }
        // });
        // this.listDocuments = list;
        this.listDocuments = response.json();
      },
      error => {
        this.msgs = [];
        this.msgs.push( { severity: 'error', summary: 'error' } );
      }
    );
  }

  public updateDocumentsfromChild($event: Event) {
    this.getDocumentsCandidate(this.id);
  }

  public activateControl(state: boolean, control_name: string){
    if(state)
      this.form4.get(control_name).setValidators([Validators.required, Validators.minLength(10), Validators.maxLength(300)]);
    else
      this.form4.get(control_name).setValidators([]);

    this.form4.controls[control_name].updateValueAndValidity();
  }

  public strToBool(str: string) {
    return /true/.test(str);
  }

  public addContact(type: string) {
    if(type == 'familiar_structure'){
      this.contacts_candidate.push({
        familiar_structure: 1,
      });
    }
    else if(type == 'in_case_of_emergency')
    {
      this.contacts_candidate.push({
        in_case_of_emergency: 1,
      });
    }
  }

  public add_contact_candidate($event) {
    this.contacts_candidate[$event.index]= $event;
  }

  public delete_contact_candidate($event) {
    // console.log($event);
    this.contacts_candidate.splice($event.index, 1);
  }

  public changeValueSelect(eventObjetc, name_variable: string) {
    // console.log(eventObjetc.id);
    if(name_variable == "residenceCountryId") {
      this.residenceCountryId = eventObjetc.id;
      this.residenceAdministrativeDivisionId = null;
      this.residenceMunicipalityId = null;
    } else if(name_variable == "residenceAdministrativeDivisionId") {
      this.residenceAdministrativeDivisionId = eventObjetc.id;
      this.residenceMunicipalityId = null;
    }

    if(name_variable == "birthCountryId") {
      this.birthCountryId = eventObjetc.id;
      this.birthAdministrativeDivisionId = null;
      this.birthMunicipalityId = null;
    } else if(name_variable == "birthAdministrativeDivisionId") {
      this.birthAdministrativeDivisionId = eventObjetc.id;
      this.birthMunicipalityId = null;
    }
  }

  public getId(value) {
    var out = null;
    if(value != undefined) {
      if(value != "") {
        if(value != null) {
          if(value.id)
            out = value.id;
          else
            out = value;
        }
      }
    }
    return out;
  }

  public addExperience() {
    this.work_experience.push({
      experience_structure: 1,
    });
  }

  public add_experience_candidate($event) {
    this.work_experience[$event.index] = $event;
  }

  public delete_experience_candidate($event) {
    // console.log($event);
    this.work_experience.splice($event.index, 1);
  }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/candidate/components/candidate-hv/candidate-hv.component.ts